import { CalendarDays } from 'lucide-react';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface Props {
  label: string;
  required?: boolean;
  value?: Date | null;
  onChange?: (date: Date | null) => void;
  error?: boolean;
}

export const FormDatePicker: React.FC<Props> = ({ label, required, value, onChange, error }) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      <label className="font-18 text-white font-medium">
        {label} {required && <span className="text-[#FF0000]">*</span>}
      </label>

      <div className="relative w-full">
        <DatePicker
          selected={value}
          onChange={onChange}
          placeholderText="dd/mm/yyyy"
          dateFormat="dd/MM/yyyy"
          minDate={new Date()}
          wrapperClassName="w-full"
          className={`w-full bg-transparent border rounded-md pl-8 px-3 py-2 text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-blue-500
           ${error ? 'border-red-500' : 'border-white/20'}`}
          calendarClassName="bg-[#0b0b0f] text-white border border-white/10 rounded-xl"
          dayClassName={() => 'hover:bg-indigo-500 rounded-full'}
        />

        <CalendarDays
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
        />
      </div>
    </div>
  );
};
